<template>
	<div>
		<div v-if="title">
			<div :class="dynvibeBox === true ? 'dynvibeBox' : ''">
				<div class="col-lg-12 dynvibeTitleBox">
					<div
						v-if="editable"
						id="filterListWord"
						class="buttonWordCloud iconeEditWordCloud"
						title="edit"
						@click="showDatatable = true"
					>
						<img
							alt="edit"
							src="https://upload.wikimedia.org/wikipedia/commons/6/64/Edit_icon_%28the_Noun_Project_30184%29.svg"
							style="width: 24px !important; height: 24px !important"
						/>
					</div>
					<div class="buttonWordCloud iconeEditWordCloud" v-if="axios == 'wordcloudKeywords'">
						<select class="selectLanguage" v-model="selectedlanguage">
							<option value="">Select a language</option>
							<option v-for="(item, index) in languages" :key="index" :value="item.key">
								{{ item.key }}
							</option>
						</select>
					</div>
					<h2>{{ title }}</h2>
				</div>
				<div class="col-lg-12">
					<div v-if="loading" class="dynvibeLoading"></div>
					<div v-if="!loading && noData" class="noData">
						<p>No Data to display</p>
					</div>
					<div ref="vuetagcloud" class="vue-tag-cloud">
						<span
							v-for="(word, index) in wordVisibleArray"
							v-bind:key="index"
							:ref="word.text"
							v-bind:class="word.class"
							@click="wordClicked"
							>{{ word.text }}
						</span>
					</div>
					<dynvibegraphdetails v-show="showGraphDetails" :axios="axios" ref="graphDetails"> </dynvibegraphdetails>
				</div>
			</div>
		</div>
		<div v-else>
			<div :class="dynvibeBox === true ? dynvibeBox : ''">
				<div class="col-lg-12">
					<div v-if="loading" class="dynvibeLoading"></div>
					<div v-if="!loading && noData" class="noData">
						<p>No Data to display</p>
					</div>
					<div ref="vuetagcloud" class="vue-tag-cloud">
						<span
							v-for="word in wordVisibleArray"
							v-bind:key="word.text"
							:ref="word.text"
							v-bind:class="word.class"
							@click="wordClicked"
							>{{ word.text }}
						</span>
					</div>
					<dynvibegraphdetails v-show="showGraphDetails" :axios="axios" ref="graphDetails"> </dynvibegraphdetails>
				</div>
			</div>
		</div>
		<div v-if="showDatatable">
			<transition name="modal">
				<div class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-dialog modal-lg">
							<div class="modal-content">
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox">
										<h5 class="modal-title">
											<span class="dynvibeModalTitle">Edit wordcloud</span>
											<button type="button" class="close" @click="refreshWordcloud">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<datatable
										ref="datatable"
										:data="wordArrayFormatted"
										:editable="false"
										:headers="headers"
										:handler="true"
										:searchable="true"
										:rulespage="false"
									>
										<template v-slot:cell="{}">
											{{ value }}
										</template>
										<template v-slot:handle="{ indexrow: indexRow }">
											<span v-if="wordArray[indexRow].display" @click="toggleDisplay(indexRow)"> ✔ </span>
											<span v-else @click="toggleDisplay(indexRow)"> ✘ </span>
										</template>
									</datatable>
									<div class="dynvibeRow">
										<div class="col-md-12">
											<div class="text-center">
												<button class="dynvibeButton" @click="refreshWordcloud">Refresh</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<!--suppress JSJQueryEfficiency -->
<script>
import dynvibegraphdetails from "@/components/vueCharts/GraphDetails.vue";
import datatable from "@/components/globalVue/datatable.vue";

export default {
	name: "dynvibewordcloud",
	props: {
		axios: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: null,
		},
		data: {
			type: Array,
			default: () => [],
		},
		width: {
			type: Number,
			default: 800,
		},
		height: {
			type: Number,
			default: 400,
		},
		clickable: {
			default: true,
		},
		urlToGet: {
			default: "wordcloud",
		},
		editable: {
			default: true,
		},
		event: {
			default: false,
		},
		eventRelative: {
			default: false,
		},
		profileId: {
			// Profiles validation in middle
			type: String,
			default: "",
		},
		dynvibeBox: {
			// Profiles validation in middle
			type: Boolean,
			default: true,
		},
		mainkeyword: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: () => {
				return {
					gte: "",
					lte: "",
				};
			},
		},
		country: {
			type: String,
			default: "",
		},
	},
	components: {
		dynvibegraphdetails: dynvibegraphdetails,
		datatable: datatable,
	},
	data() {
		return {
			loading: true,
			noData: false,
			wordArray: this.data,
			wordVisibleArray: this.data,
			cloud_namespace: Math.floor(Math.random() * 1000000).toString(36),
			options: {
				width: this.width,
				height: this.height,
				center: {
					x: this.width / 2.0,
					y: this.height / 2.0,
				},
				removeOverflowing: true,
			},
			already_placed_words: [],
			showGraphDetails: false,
			showDatatable: false,
			url: this.urlToGet,
			mastertagEventWC: null,
			togglebutton: false,
			margin: 30,
			headers: ["Word", "Recurrence", "Display"],
			languages: [],
			selectedlanguage: "",
		};
	},
	computed: {
		wordArrayFormatted() {
			let out = [];
			this.wordArray.forEach((v) => {
				out.push([v.text, v.weight]);
			});
			return out;
		},
	},
	methods: {
		// set parameters
		loadComponent(parameters, tagclass = "", word = null, mastertagEventWC = null) {
			this.wordArray = [];
			this.wordVisibleArray = [];
			let params = {
				parameters: parameters,
				data: {
					function: this.axios,
				},
			};

			if (this.eventRelative) {
				// If we just clicked on "back to previous graph", graphDetails gives us the previously active word
				this.mastertagEventWC = mastertagEventWC;
				params.tagclass = tagclass;
				params.parameters.mastertagEvent = word;
				params.parameters.tagclassWC = tagclass;
			}
			this.loading = true;

			// Profiles validation in middle
			if (this.profileId) {
				params.data.profileId = this.profileId;
			}
			// modal create mastertag / trend
			if (this.mainkeyword) {
				params.data.mainkeyword = this.mainkeyword;
				params.data.level = this.level;
			} else if (this.level) {
				params.data.level = this.level;
			}
			if (this.selectedlanguage) {
				params.data.lang = this.selectedlanguage;
			}

			// call getData(url) from mixin
			this.selectedlanguag = "";
			//console.log(params);
			if (this.date.gte != "") {
				params.parameters.date = this.date;
			}
			if (this.country != "") {
				params.parameters.country = [this.country];
			}

			this.getData(this.url, params);
			this.updateWordcloud();
		},
		treatResponse(response) {
			this.loading = false;
			if (!response.data) {
				this.noData = true;
			} else {
				this.noData = false;
				if (this.axios == "wordcloudKeywords") {
					this.wordArray = response.data.results;
					this.languages = response.data.languages;
					if (this.selectedlanguage == "") {
						this.selectedlanguage = this.languages[0].key;
					}
				} else {
					this.wordArray = response.data;
				}

				this.wordArray.forEach((a) => (a.display = true));
				this.wordVisibleArray = this.wordArray.filter(function (a) {
					return a.display === true;
				});

				this.constituteBuckets();

				// need to wait for next tick before call updateWordcloud
				// wordArray is set so it's updated in the v-for
				this.$nextTick(() => {
					this.updateWordcloud();
					// If we just clicked on "back to previous graph", graphDetails gave us the previously active word and we recolor it
					if (this.mastertagEventWC) {
						this.$refs[this.mastertagEventWC][0].classList.add("active");
					}
				});
			}
			if (this.wordArray.length === 0) {
				this.noData = true;
			}
			this.$emit("worcloudloaded");
		},
		changeUrl(newUrl) {
			this.url = this.$backendUrl + newUrl;
			this.loadComponent(this.$store.getters.parameters);
		},
		constituteBuckets() {
			let totalWeight = this.wordVisibleArray.reduce((x, y) => {
				return x + parseInt(y.weight);
			}, 0);
			let mean = totalWeight / this.wordVisibleArray.length;
			/*let variance = 0;

			this.wordVisibleArray.forEach((word) => {
				variance += Math.pow(Math.abs(word.weight - mean), 2);
			});*/

			let ecartType = 0;

			this.wordVisibleArray.forEach((word, index) => {
				if (index > 0) {
					ecartType += parseInt(this.wordVisibleArray[index - 1].weight) - parseInt(word.weight);
				}
			});

			ecartType = ecartType / (this.wordVisibleArray.length - 1);

			let buckets = [];
			let bucketIndex = 0;
			this.wordVisibleArray.forEach((word, index) => {
				if (index === 0) {
					buckets[bucketIndex] = [word];
				} else if (this.wordVisibleArray[index - 1].weight - word.weight <= ecartType) {
					buckets[bucketIndex].push(word);
				} else {
					bucketIndex += 1;
					buckets[bucketIndex] = [word];
				}
			});

			buckets.forEach((bucket) => {
				let totalBucket = bucket.reduce((x, y) => {
					return x + parseInt(y.weight);
				}, 0);
				let meanBucket = totalBucket / bucket.length;
				let category;
				if (meanBucket >= mean) {
					category = [1, 1.25, 1.5, 5, 10].reduce((a, b) => {
						return Math.abs(b - meanBucket / mean) < Math.abs(a - meanBucket / mean) ? b : a;
					});
				} else {
					category = [1, 1.25, 1.5, 5, 10].reduce((a, b) => {
						return Math.abs(b - mean / meanBucket) < Math.abs(a - mean / meanBucket) ? b : a;
					});
					category = -category;
				}
				if (category > 10) {
					category = 10;
				} else if (category < -10) {
					category = -10;
				}

				let mappingCategoryClass = {
					10: 10,
					5: 9,
					1.5: 8,
					1.25: 7,
					1: 6,
					"-1": 5,
					"-1.25": 4,
					"-1.5": 3,
					"-5": 2,
					"-10": 1,
				};
				bucket.forEach((word) => {
					word.class = "w" + mappingCategoryClass[category] + " " + word.html.class;
				});
			});
		},
		updateWordcloud() {
			// get the updated width and height from the vuetagcloud ref
			if (this.$refs.vuetagcloud && this.$refs.vuetagcloud.parentNode.clientWidth !== 0) {
				this.options.width = this.$refs.vuetagcloud.parentNode.clientWidth - this.margin;
			}

			if (this.$refs.vuetagcloud && this.$refs.vuetagcloud.parentNode.clientHeight !== 0 && !this.options.height) {
				this.options.height = this.$refs.vuetagcloud.parentNode.clientHeight - this.margin;
			}

			// compute center
			this.options.center.x = this.options.width / 2.0;
			this.options.center.y = this.options.height / 2.0;

			// remove all items from the array
			this.already_placed_words = [];

			if (this.wordVisibleArray) {
				this.wordVisibleArray.forEach(
					function (word, index) {
						// for each word we update the left and top position
						this.updateWordPosition(index, word);
						this.already_placed_words.push(word);
					}.bind(this)
				);
			}
		},
		// event triggered when click on a word
		wordClicked(event) {
			// If it is a wordcloud in a graphDetails
			let word = event.target.innerText;

			if (this.mainkeyword !== "") {
				this.$emit("wordcloudclicked", word);
			} else if (this.eventRelative) {
				if (this.$refs[word][0].className.includes("active") || this.$refs[word][0].className.includes("colorActive")) {
					this.$refs[word][0].classList.remove("active");
					this.$emit("reloadoutergraphdetail", null);
				} else {
					let spans = document.getElementsByTagName("span");
					for (let i = 0; i < spans.length; i++) {
						spans[i].classList.remove("active", "colorActive");
					}
					//$("span").removeClass("active colorActive");
					this.$refs[word][0].classList.add("active");
					this.$emit("reloadoutergraphdetail", word);
				}
			} else if (this.clickable) {
				if (word.length > 0) {
					this.$refs.graphDetails.getDataWordCloud(word, this.event, true, true);
				}
				this.showGraphDetails = true;
			}
		},

		// compute left and top position and change the span position of the word
		updateWordPosition(index, word) {
			if (!this.$refs[word.text]) {
				return;
			}
			let width = this.$refs[word.text].offsetWidth;
			let height = this.$refs[word.text].offsetHeight;
			let left = this.options.center.x - width / 2.0;
			let top = this.options.center.y - height / 2.0;
			let radius = 0.0;
			let angle = 6.28 * Math.random();

			let position = "absolute";

			let step = 2.0;
			let aspect_ratio = this.options.width / this.options.height;

			this.$refs[word.text].style.left = left + "px";
			this.$refs[word.text].style.top = top + "px";
			this.$refs[word.text].style.position = position;
			while (this.hitTest(word, this.already_placed_words)) {
				radius += step;
				angle += (index % 2 === 0 ? 1 : -1) * step;

				left = this.options.center.x - width / 2.0 + radius * Math.cos(angle) * aspect_ratio;
				top = this.options.center.y + radius * Math.sin(angle) - height / 2.0;

				this.$refs[word.text].style.left = left + "px";
				this.$refs[word.text].style.top = top + "px";
				this.$refs[word.text].style.position = position;
			}

			if (
				this.options.removeOverflowing &&
				(left < 0 || top < 0 || left + width > this.options.width || top + height > this.options.height)
			) {
				this.$refs[word.text].style.display = "none";
			}
		},
		// check if the two elements are not in collision
		hitTest(elem, other_elems) {
			// Pairwise overlap detection
			// this.$refs[a.text].offsetHeight
			let overlapping = (a, b) => {
				a = this.$refs[a.text];
				b = this.$refs[b.text];

				if (Math.abs(2.0 * a.offsetLeft + a.offsetWidth - 2.0 * b.offsetLeft - b.offsetWidth) < a.offsetWidth + b.offsetWidth) {
					if (
						Math.abs(2.0 * a.offsetTop + a.offsetHeight - 2.0 * b.offsetTop - b.offsetHeight) <
						a.offsetHeight + b.offsetHeight
					) {
						return true;
					}
				}
				return false;
			};
			let i = 0;

			// Check elements for overlap one by one, stop and return true as soon as an overlap is found
			for (i = 0; i < other_elems.length; i++) {
				if (elem)
					if (overlapping(elem, other_elems[i])) {
						return true;
					}
			}
			return false;
		},
		toggleDisplay(indexRow) {
			this.wordArray[indexRow].display = !this.wordArray[indexRow].display;
			this.wordArray = this.wordArray.slice(); // don't know why I have to copy the array,
			// to see changes =>
			//answer to see changes the reference of the object mst be changed to be observed,
			// changing inner object elements wont result in changing its reference therefore, the watcher will not detect a change

			this.wordVisibleArray = this.wordArray.filter(function (a) {
				return a.display === true;
			});
			this.constituteBuckets();
		},
		refreshWordcloud() {
			this.constituteBuckets();
			// need to wait for next tick before call updateWordcloud
			// wordArray is set so it's updated in the v-for
			this.$nextTick(() => {
				this.updateWordcloud();
			});
			this.showDatatable = false;
		},
	},
	watch: {
		"$store.state.parameters": function () {
			this.loadComponent(this.$store.getters.parameters);
		},
		selectedlanguage() {
			if (this.loading == false) {
				if (this.explorePage == true) {
					this.loadComponent(this.$parent.$parent.filters);
				} else {
					this.loadComponent(this.$store.getters.parameters);
				}
			}
		},
	},
};
</script>

<style scoped>
.selectLanguage {
	/* align-items: center; */
	/* height: 20px; */
	max-width: 200px;
	min-width: 100px;
	padding: 0px 4px 0px 7px;
	margin: 0px 10px 5px 0px;
	border-radius: 12px;
	font-size: 13px;
	font-weight: 700;
	border: 1px solid #cacaca;
	color: #8e8e8e;
	outline: 0;
}
.modal-active {
	display: block;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.dynvibeTitleBox {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeModalTitle {
	font-size: 16px;
	font-weight: 700;
	text-transform: uppercase;
}

.buttonWordCloud {
	cursor: pointer;
}

.iconeEditWordCloud {
	float: right;
}

.getMoreWordsWordCloud {
	display: block;
	font-size: 14px;
	font-weight: 600;
	padding: 10px 15px;
	border: none;
	text-transform: uppercase;
	outline: 0;
	margin: auto auto 1em;
}

div#wordcloudEventsRelative span.active {
	color: #fd0101;
	font-weight: bold;
}

.refreshWordCloud {
	display: block;
	margin: auto;
	font-size: 14px;
	font-weight: 600;
	padding: 10px 15px;
	border: none;
	text-transform: uppercase;
	outline: 0;
}

.vue-tag-cloud {
	font-family: "Intro", "Arial", "Helvetica", "sans-serif";
	font-size: 10px;
	line-height: normal;
	width: auto;
	display: inline-block;
	position: relative;
	min-height: 390px;
	height: auto;
	color: #09f;
}

.vue-tag-cloud a {
	font-size: inherit;
	text-decoration: none;
	color: inherit;
}

.vue-tag-cloud a:hover {
	color: #0df;
}

.vue-tag-cloud span {
	padding: 0;
	cursor: pointer;
	white-space: nowrap;
}

.vue-tag-cloud span.active.color1,
.vue-tag-cloud span.active.color2,
.vue-tag-cloud span.colorActive,
.vue-tag-cloud span.colorActive {
	color: #fd0101 !important;
	font-weight: bold;
}

.vue-tag-cloud span.w10 {
	font-size: 450%;
}

.vue-tag-cloud span.w9 {
	font-size: 380%;
}

.vue-tag-cloud span.w8 {
	font-size: 322%;
}

.vue-tag-cloud span.w7 {
	font-size: 273%;
}

.vue-tag-cloud span.w6 {
	font-size: 231%;
}

.vue-tag-cloud span.w5 {
	font-size: 195%;
}

.vue-tag-cloud span.w4 {
	font-size: 165%;
}

.vue-tag-cloud span.w3 {
	font-size: 140%;
}

.vue-tag-cloud span.w2 {
	font-size: 118%;
}

.vue-tag-cloud span.w1 {
	font-size: 100%;
}

.vue-tag-cloud span.w10.color1 {
	color: rgba(51, 209, 205, 1);
}

.vue-tag-cloud span.w9.color1 {
	color: rgba(51, 209, 205, 1);
}

.vue-tag-cloud span.w8.color1 {
	color: rgba(51, 209, 205, 0.8);
}

.vue-tag-cloud span.w7.color1 {
	color: rgba(51, 209, 205, 0.8);
}

.vue-tag-cloud span.w6.color1 {
	color: rgba(51, 209, 205, 0.6);
}

.vue-tag-cloud span.w5.color1 {
	color: rgba(51, 209, 205, 0.6);
}

.vue-tag-cloud span.w4.color1 {
	color: rgba(51, 209, 205, 0.6);
}

.vue-tag-cloud span.w3.color1 {
	color: rgba(128, 128, 128, 1);
}

.vue-tag-cloud span.w2.color1 {
	color: rgba(128, 128, 128, 0.8);
}

.vue-tag-cloud span.w1.color1 {
	color: rgba(128, 128, 128, 0.8);
}

.vue-tag-cloud span.w10.color2 {
	color: rgba(73, 27, 183, 1);
}

.vue-tag-cloud span.w9.color2 {
	color: rgba(73, 27, 183, 1);
}

.vue-tag-cloud span.w8.color2 {
	color: rgba(73, 27, 183, 0.8);
}

.vue-tag-cloud span.w7.color2 {
	color: rgba(73, 27, 183, 0.8);
}

.vue-tag-cloud span.w6.color2 {
	color: rgba(73, 27, 183, 0.6);
}

.vue-tag-cloud span.w5.color2 {
	color: rgba(73, 27, 183, 0.6);
}

.vue-tag-cloud span.w4.color2 {
	color: rgba(73, 27, 183, 0.6);
}

.vue-tag-cloud span.w3.color2 {
	color: rgba(128, 128, 128, 1);
}

.vue-tag-cloud span.w2.color2 {
	color: rgba(128, 128, 128, 0.8);
}

.vue-tag-cloud span.w1.color2 {
	color: rgba(128, 128, 128, 0.8);
}
</style>
